import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { GeneralResponse, Token } from "../../../types/api";
import { Methods } from "../../constants/CommonConstants";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { IChangeDrugStatusRequest } from "../../../types/apis/drugs";

export const ChangeDrugStauts = async (
  payload: IChangeDrugStatusRequest,
  token: Token,
): Promise<GeneralResponse> => {
  try {
    const response = await Api<any, GeneralResponse<IChangeDrugStatusRequest>>({
      method: Methods.POST,
      endpoint: `${EndPoints.changeDrugStatus}/${payload.DrugId}`,
      body: payload.StatusPayload,
      token,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useChangeDrugStauts = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    { payload: IChangeDrugStatusRequest; token: Token }
  > = useMutation({
    mutationFn: ({ payload, token }) => ChangeDrugStauts(payload, token),
    ...options,
  });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
